import Icon from '../components/Icon.vue'

Icon.register({
  'th-large': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M296 32h192c13.3 0 24 10.7 24 24v160c0 13.3-10.7 24-24 24h-192c-13.3 0-24-10.7-24-24v-160c0-13.3 10.7-24 24-24zM216 32c13.3 0 24 10.7 24 24v160c0 13.3-10.7 24-24 24h-192c-13.3 0-24-10.7-24-24v-160c0-13.3 10.7-24 24-24h192zM0 296c0-13.3 10.7-24 24-24h192c13.3 0 24 10.7 24 24v160c0 13.3-10.7 24-24 24h-192c-13.3 0-24-10.7-24-24v-160zM296 480c-13.3 0-24-10.7-24-24v-160c0-13.3 10.7-24 24-24h192c13.3 0 24 10.7 24 24v160c0 13.3-10.7 24-24 24h-192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/th-large.js
// module id = 1994
// module chunks = 0